'use client';

import type { LeagueEvent } from '@interfaces/APITravel';
import { useEffect } from 'react';

type Props = {
  event?: LeagueEvent | null;
  enabled?: boolean;
};

/**
 * Warms the stadium/downtown location lookup (SWR + sessionStorage cache)
 * while the user is still in the build-package flow, so the /search-hotel
 * PageLoader gate resolves instantly after navigation. Renders nothing.
 */
export function PrefetchHotelSearchArea({ event, enabled = true }: Props) {
  useEffect(() => {
    if (!enabled || !event?.id) return;
    void import('@v2/views/SearchHotel/hooks/use-hotel-search-area')
      .then(({ prefetchHotelSearchArea }) => prefetchHotelSearchArea(event))
      .catch(() => null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event?.id, enabled]);

  return null;
}
